/**
 * @module events/types/paste
 */

/**
 * @type {string}
 */
export default 'paste'
